export default __webpack_public_path__ + "static/media/prevencao-kids-min.ff3d4e40.png";